<template>
  <div class="chat-display-page col-block width-full">
    <div class="chat-display-container col-block width-full">
      <div class="chat-display-block row-block flex-start" v-for="(chatData, cdindex) in chatDatas" :key="cdindex">
        <div v-if="chatData.msgType" class="avatar-block" :style="{ '--size': '40px' }">
          <img v-if="chatData.msgType === 'answer'" :src="require('../../assets/images/bot-avatar.svg')" alt="">
        </div>
        <div
          class="chat-display-content-container col-block"
          :class="[{
            'answer': 'flex-start',
            'question': 'flex-end'
          }[chatData.msgType]] || 'stretch'"
          :style="{ flex: 1 }"
        >
          <template v-if="chatData.type === 'loading'">
            <div class="chat-display-content-block break-line" :class="{ 'bot-loading': !botAnswering }">
              <template v-if="botAnswering">
                <span v-html="botAnswering"></span>
              </template>
              <template v-else>
                <img :src="require('../../assets/images/upload.svg')" alt="">
              </template>
            </div>
          </template>
          <template v-else-if="chatData.type === 'stop'">
            <div class="chat-display-content-block bot-stop break-line">
              <span>{{ $t('COMPONENT.chat.display.___stopMsg') }}</span>
            </div>
          </template>
          <template v-else>
            <div class="chat-display-content-block break-line">
              <span>{{ chatData.message }}</span>
            </div>
          </template>
        </div>
        <div v-if="chatData.msgType" class="avatar-block" :style="{ '--size': '40px' }">
          <img v-if="chatData.msgType === 'question'" :src="avatarUrl" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userPermission from '../../mixins/userPermission.vue'

export default {
  mixins: [
    userPermission
  ],
  props: {
    chats: {
      type: Array,
      default: () => []
    },
    botState: {
      type: String,
      default: () => ''
    },
    botAnswering: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    chatDatas () {
      let botExtraChats = {
        'loading': [
          {
            type: 'loading',
            msgType: 'answer'
          }
        ],
        'stop': [
          {
            type: 'stop'
          }
        ]
      }[this.botState] || []
      return [
        ...this.chats,
        ...botExtraChats
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/display.vue